import PropTypes from "prop-types";
import Modal from "../../Modal/Modal";
import BillingProfileForm from "../../BillingProfile/BillingProfileForm";

function BillingProfileSettingsModal({
	isOpen,
	onClose,
	title,
	closeLabel,
	user,
	onSuccess,
	submitLabel,
	modalTitle,
	modalDescription,
}) {
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={title}
			maxWidth="720px"
			maxHeight="90vh"
			overflowY="auto"
			hideHeader
			closeLabel={closeLabel}
		>
			<BillingProfileForm
				initialValues={{
					legalName: user?.legalName,
					taxId: user?.taxId,
					billingCountry: user?.billingCountry,
					vatTreatment: user?.vatTreatment,
					billingAddress: user?.billingAddress,
				}}
				onSuccess={onSuccess}
				onCancel={onClose}
				submitLabel={submitLabel}
				title={modalTitle}
				description={modalDescription}
			/>
		</Modal>
	);
}

BillingProfileSettingsModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	closeLabel: PropTypes.string.isRequired,
	user: PropTypes.object,
	onSuccess: PropTypes.func.isRequired,
	submitLabel: PropTypes.string.isRequired,
	modalTitle: PropTypes.string.isRequired,
	modalDescription: PropTypes.string.isRequired,
};

export default BillingProfileSettingsModal;
